import script from "./MailBoxLV.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBoxLV.vue?vue&type=script&setup=true&lang=js"

import "./MailBoxLV.vue?vue&type=style&index=0&id=6df6a04d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df6a04d"]])

export default __exports__